<template>
    <div class="row" >
        <div v-if="loading" class="lds-dual-ring"></div>
        <ValidationObserver ref="form" v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Status</div>
                    </div>
                    <div class="form mt-3">
                        <div class="row mb-3">
                            <div class="col-md-12">
                                <div class="d-flex ">
                                    <div class="form-group form-group-1 mr-5">
                                        <ValidationProvider
                                            name="status"
                                            rules="required"
                                            v-slot="{ errors }"
                                            class="form-check">
                                            <input
                                                class="form-check-input-radio"
                                                type="radio"
                                                name="12"
                                                id="pending"
                                                v-model="stage.status"
                                                value="in_process"
                                            >
                                            <label class="form-check-label" for="pending">
                                                In Process
                                            </label>
                                            <FormError :error="errors[0]" name="status"></FormError>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group form-group-1">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-radio"
                                                type="radio"
                                                name="12"
                                                id="active"
                                                value="active"
                                                v-model="stage.status"
                                            >
                                            <label class="form-check-label" for="active">
                                                Active
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ValidationProvider
                                class="col-md-12"
                                name="name"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Name of stage</label>
                                    <input type="text" class="form-control" v-model="stage.name">
                                    <FormError :error="errors[0]" name="status"></FormError>
                                </div>
                            </ValidationProvider>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Read only text</label>
                                    <textarea type="text" class="form-control height-2" v-model="stage.text"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input-radio"
                                            type="checkbox"
                                            name="122"
                                            id="12345"
                                            :value="true"
                                            v-model="stage.show_note"
                                        >
                                        <label class="form-check-label" for="12345">
                                            Text box for stage related note
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="box-ttl-wrap mb-3">
                        <div class="box-ttl">Add checklist item ({{ stage.checklist.length }})</div>
                        <button
                            class="btn btn--outline-primary btn--middle"
                            @click="addNewItem"
                        >+ Add New Item
                        </button>
                    </div>
                    <div v-for="(item, index) in stage.checklist"
                         :key="index">
                        <div class="dashed-border-block"
                             v-if="activeItem !== item"
                        >
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <p class="mb-0"><b>{{ item.title }}</b></p>
                                </div>
                                <div class="col-4 text-right">
                                    <button
                                        class="img-btn"
                                        @click="editItem(item)"
                                    ><img src="/img/svg/edit.svg" alt=""></button>
                                    <button
                                        class="img-btn ml-3"
                                        @click="deleteItem(index)"
                                    ><img src="/img/svg/on.svg" alt=""></button>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-4" v-if="activeItem === item">
                            <div class="form-group form-group-1 mb-0 w-100" style="flex-grow: 1">
                                <input type="text" v-model="item.title" class="form-control">
                            </div>
                            <button
                                class="img-btn ml-3"
                                @click="saveItem(item)"
                            ><img src="/img/svg/check-5.svg" alt=""></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="btns-wrap">
                                <button class="btn btn--outline-primary w-100 w-sm-auto" @click="showDeleteModal">
                                    Cancel
                                </button>
                                <ActionModal confirm-text="Yes" reject-text="No" :modalId="`cancel`"
                                             @confirm="backToList">
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you don’t want <br> to save the changes?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                                <button class="btn btn--secondary w-100 w-sm-auto" @click="validateForm">Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>

</template>

<script>
import StatusService from "./services/StatusService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";

export default {
    name: 'StatusItem',
    components: {ActionModal},
    props: {
        item: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            activeItem: {},
            isUpdate: false,
            loading: true,
            stage: {
                checklist: [],
                name: '',
                show_note: false,
                status: null,
                text: '',
            },
            statusInfo: this.item,
        }
    },
    methods: {
        addNewItem() {
            const newItem = {
                title: this.task,
                isChecked: false
            };
            this.stage.checklist.push(newItem);
            this.activeItem = newItem;
        },
        backToList() {
            window.location.href = '/master-admin/settings/status'
        },
        deleteItem(index) {
            this.stage.checklist.splice(index, 1);
        },
        editItem(item) {
            this.activeItem = item;
        },
        saveItem(item) {
            if (!item.title || item.title.trim() === '') {
                this.$showErrorMessage('Please enter title for checkbox')
            } else {
                this.activeItem = {};
            }
        },
        async saveStage() {
            this.$showLoadingMessage()
            try {
                await StatusService.saveNewStage(this.stage)
                this.$showSuccessMessage('New Stage was saved!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/status'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Failed to save your information, try again')
            }
        },
        setData(stage) {
            for (const fullKey in this.statusInfo) {
                for (const emptyKey in stage) {
                    if (fullKey === emptyKey) {
                        stage[fullKey] = this.statusInfo[emptyKey];
                    }
                }
            }
            this.loading = false
        },
        showDeleteModal() {
            $(`#cancel`).modal()
        },
        async updateExistStage() {
            this.$showLoadingMessage()
            try {
                await StatusService.updateStatus(this.statusInfo.id, this.stage)
                this.$showSuccessMessage('Stage was updated!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/status'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            if (this.isUpdate === false) {
                await this.saveStage()
            } else {
                await this.updateExistStage()
            }
        },
    },

    mounted() {
        const currentPath = window.location.pathname;

        if (currentPath === '/master-admin/settings/status/create') {
            this.isUpdate = false;
            this.loading = false;
        } else {
            this.isUpdate = true
            this.setData(this.stage);
        }
    }

}

</script>

<style scoped>

</style>
